/** @format */
import { css } from 'styled-components';

import { StyledTruncateTextProps } from './index';

const baseStyles = ({ lines, truncateText }: StyledTruncateTextProps) => css`
    display: flex;
    flex-direction: column;

    .text-container {
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: ${lines};
        -webkit-box-orient: vertical;
        white-space: normal;
        display: ${truncateText ? '-webkit-box' : 'block'};
    }

    .expander {
        width: fit-content;
    }
`;

export const styles = (props: StyledTruncateTextProps) => css`
    ${baseStyles(props)}
`;
